import { Box, Container } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import MainAppBarComponent from "../components/appBars/MainAppBarComponent";
import AnnouncementCarouselComponent from "../components/carousel/AnnouncementCarouselComponent";
import { SampleFooterComponent } from "../components/footers/SampleFooterComponent";
import { LicencesMainPageComponent } from "../components/pages/licences/MainPageComponent";
import { WaveShapeComponent } from "../components/shapes/WaveShapeComponent";

const LicencesPage = () => {
  return (
    <Container maxWidth="xl" disableGutters={true}>
      <LicencesMainPageComponent />
    </Container>
  );
};

export default LicencesPage;
